import { Box, Typography, useTheme, useMediaQuery } from "@mui/material";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Legend,
} from "recharts";

export default function MonthlyAttendanceDetail({ data, onDayClick }) {
  const theme = useTheme();
  const isSmall = useMediaQuery(theme.breakpoints.down("sm"));

  const overview = data?.monthlyAttendanceOverview;
  const daily = overview?.dailyBreakdown || [];

  const chartData = daily.map((d) => ({
    date: d.date?.slice(8) || "",
    fullDate: d.date,
    Present: d.present,
    Absent: d.absent,
  }));

  const handleBarClick = (barData) => {
    if (onDayClick && barData?.fullDate) {
      onDayClick(barData.fullDate);
    }
  };

  return (
    <Box
      sx={{
        background: "#fff",
        borderRadius: "16px",
        p: 2,
        boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
        height: "100%",
      }}
    >
      <Typography
        sx={{ fontWeight: 700, fontSize: "16px", color: "#333", mb: 1 }}
      >
        Monthly Attendance Overview
      </Typography>

      {/* Summary stats */}
      <Box sx={{ display: "flex", gap: 2, mb: 2, flexWrap: "wrap" }}>
        {[
          {
            label: "Total Present",
            value: overview?.totalPresent ?? "-",
            color: "#2E7D32",
          },
          {
            label: "Total Absent",
            value: overview?.totalAbsent ?? "-",
            color: "#D32F2F",
          },
          {
            label: "Working Days",
            value: overview?.workingDaysSoFar ?? "-",
            color: "#1565C0",
          },
        ].map((s, i) => (
          <Box
            key={i}
            sx={{
              px: 2,
              py: 1,
              borderRadius: "10px",
              background: `${s.color}10`,
              border: `1px solid ${s.color}30`,
            }}
          >
            <Typography sx={{ fontSize: "11px", color: "#666" }}>
              {s.label}
            </Typography>
            <Typography sx={{ fontSize: "18px", fontWeight: 700, color: s.color }}>
              {s.value}
            </Typography>
          </Box>
        ))}
      </Box>

      {/* Chart */}
      {chartData.length > 0 ? (
        <ResponsiveContainer width="100%" height={isSmall ? 200 : 250}>
          <BarChart
            data={chartData}
            margin={{ top: 10, right: 10, left: 0, bottom: 5 }}
          >
            <CartesianGrid strokeDasharray="3 3" vertical={false} />
            <XAxis
              dataKey="date"
              tick={{ fontSize: isSmall ? 9 : 11, fill: "#666" }}
              interval={isSmall ? 2 : 1}
            />
            <YAxis tick={{ fontSize: 11, fill: "#666" }} />
            <Tooltip />
            <Legend wrapperStyle={{ fontSize: 12 }} />
            <Bar
              dataKey="Present"
              fill="#4CAF50"
              radius={[4, 4, 0, 0]}
              barSize={isSmall ? 8 : 14}
              onClick={handleBarClick}
              style={{ cursor: "pointer" }}
            />
            <Bar
              dataKey="Absent"
              fill="#FF7043"
              radius={[4, 4, 0, 0]}
              barSize={isSmall ? 8 : 14}
              onClick={handleBarClick}
              style={{ cursor: "pointer" }}
            />
          </BarChart>
        </ResponsiveContainer>
      ) : (
        <Typography textAlign="center" color="textSecondary" sx={{ py: 4 }}>
          No attendance data available for this month.
        </Typography>
      )}
    </Box>
  );
}
